import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

export default function ProgramCard({ title, description, image, link, icon: Icon }) {
  return (
    <div className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
        {Icon && (
          <div className="absolute bottom-4 left-4">
            <Icon className="w-12 h-12 text-white" />
          </div>
        )}
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-bold text-primary mb-3">{title}</h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{description}</p>
        <Link 
          to={link} 
          className="inline-flex items-center space-x-2 text-secondary hover:text-orange-600 font-semibold transition-colors"
        >
          <span>Learn More</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  )
}
